import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';
import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';
import SuspenseLoader from '@cp/src/components/SkeletonLoader/SuspenseLoader';
import { RootState } from '@cp/src/store';
import { copyToClipboard } from '@cp/src/utils/commonUtils';
import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { AnomalyTableKeys } from '../../types';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';

const AnomalyModalHeader = () => {
  const params = readQueryParams();
  const selectedAnomalyId = params?.[AnomalyTableKeys.ANOMALY_TABLE_ACTION]?.selectedId;
  const isLoading = useSelector(
    (state: RootState) => state?.anomalyTracker?.anomalyDetails?.loading
  );
  const anomalyDetails = useSelector(
    (state: RootState) => state?.anomalyTracker?.anomalyDetails?.data
  );

  const { type, subtype, anomalyId } = anomalyDetails || {};

  const copyAnomalyUrl = () => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_ANOMALY_TRACKER_ANOMALY_COPY_LINK_CLICKED, {
      anomalyId: selectedAnomalyId
    });
    copyToClipboard(window?.location?.href)
      .then(() => {
        toast.success('Anomaly link copied');
      })
      .catch(() => {
        toast.error('Error copying to clipboard');
      });
  };

  return (
    <div>
      <div className="flex gap-2 items-center mb-2">
        <SuspenseLoader
          loading={isLoading}
          fallBack={
            <LineLoader numberOfLines={1} childrenType="H3" dimenshionUnit="px" lineWidth={300} />
          }
        >
          <Typography variant="h2" color="var(--grayscale-2)">
            Anomaly ID: {anomalyId}
          </Typography>
          <CopyToClipboardIcon
            width={20}
            height={20}
            onClick={copyAnomalyUrl}
            className="cursor-pointer"
          />
        </SuspenseLoader>
      </div>
      <SuspenseLoader
        loading={isLoading}
        fallBack={
          <LineLoader numberOfLines={1} childrenType="H3" dimenshionUnit="px" lineWidth={500} />
        }
      >
        <Typography as="span" variant="h3" color="var(--grayscale-3)">
          {type}:{' '}
          <Typography as="span" variant="h3" color="var(--grayscale-2)" className="font-normal">
            {subtype}
          </Typography>
        </Typography>
      </SuspenseLoader>
    </div>
  );
};

export default AnomalyModalHeader;
